import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
interface Props {
  open: boolean;
  onClose: () => void;
  onApprove: () => void;
  newEmail: string;
  currentEmail: string;
  otps: { currentOtp: string; newOtp: string };
}
export default function OTPDialog({ open, onClose, onApprove, newEmail, currentEmail, otps }: Props) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm OTP codes with the customer.</DialogTitle>
      <DialogContent>
        <div style={{ fontSize: '14px', marginLeft: '4px' }}>
          <strong>Current Email:</strong> {currentEmail} <br />
          <strong>OTP:</strong> {otps.currentOtp}
        </div>
        <div style={{ marginTop: '10px', fontSize: '14px', marginLeft: '4px' }}>
          <strong>New Email:</strong> {newEmail} <br />
          <strong>OTP:</strong> {otps.newOtp}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onApprove}>Approve</Button>
      </DialogActions>
    </Dialog>
  );
}